import { IError, IFetchRailOptionByDirection, RailDirection } from '../rail/interfaces'
import { IBirthdates, IExpinetFlexFlightType, IMappedGateway, ISelectedFilters, SelectableRailOptionsFlexFlight } from './interfaces'

export const useState = (): FlexFlightState => {
  return {
    availableGateways: [],
    availableFlights: [],
    selectedFlight: null,
    flexFlightMessage: '',
    birthdates: {},
    isFlexFlightSearchEnabled: false,
    railErrorMessage: '',
    railDirection: 'none',
    selectedRailOptionId: '',
    selectableRailOptions: {},
    selectedRailOption: null,
    selectedFilters: {
      gateway: null,
      flightDirection: null,
      airlines: [],
      nonstop: false,
      transportationClass: null,
    },
    requestId: '',
    isLoading: false
  }
}

export interface FlexFlightState {
  availableGateways: IMappedGateway[]
  availableFlights: IExpinetFlexFlightType[]
  selectedFlight: IExpinetFlexFlightType | null
  flexFlightMessage: string
  birthdates: IBirthdates
  isFlexFlightSearchEnabled: boolean
  railErrorMessage: string
  railDirection: RailDirection
  selectedRailOptionId: string
  selectableRailOptions: IFetchRailOptionByDirection | IError
  selectedRailOption: SelectableRailOptionsFlexFlight | null
  selectedFilters: ISelectedFilters
  requestId: string,
  isLoading: boolean
}
